import { Box, Button, Grid, TextField, Typography } from '@material-ui/core'
import { Formik } from 'formik'
import React, { useEffect, useRef, useState } from 'react'
import { object, string } from 'yup'

import ButtonSubmit from '../../common/ButtonSubmit'
import SavedLocatonNameCreateable from './SavedLocationNameCreatable'

const MAX_DELIVERY_INSTRUCTION_LIMIT = 60
const schema = object().shape({
  deliveryInstructions: string(),
  name: string(),
})

const EditSavedLocationForm = ({
  isUpdatingSavedLocation,
  location,
  primaryActions: PrimaryActions,
  setSavedLocationForEdit,
  updateSavedLocationError,
  updateUserSavedLocationStart,
}) => {
  const [instrCount, setInstrCount] = useState(0)
  const [didSave, setDidSave] = useState()
  const nameFieldRef = useRef()
  const handleCancel = () => setSavedLocationForEdit(undefined)
  const handleSubmit = values => {
    updateUserSavedLocationStart(
      location.savedLocationId,
      values.name,
      values.deliveryInstructions || null,
    )
    setDidSave(true)
  }

  // Reset
  useEffect(() => {
    if (didSave && !updateSavedLocationError && isUpdatingSavedLocation === false) {
      setSavedLocationForEdit(undefined)
      setDidSave(false)
    }
  }, [didSave, isUpdatingSavedLocation, setSavedLocationForEdit, updateSavedLocationError])

  return (
    <Formik
      initialValues={{
        deliveryInstructions: location?.deliveryInstructions ?? '',
        name: location?.name ?? '',
      }}
      onSubmit={handleSubmit}
      validationSchema={schema}
    >
      {({ errors, handleBlur, handleChange, handleSubmit, setFieldValue, touched, values }) => (
        <Grid component={Box} container paddingY={3} spacing={3}>
          <Grid item xs={5}>
            <SavedLocatonNameCreateable
              defaultValue={location.name}
              handleClickAway={() => setFieldValue('name', nameFieldRef.current?.value)} // Handles clicking away
              onChange={(e, value) => setFieldValue('name', value)} // Handles selecting from autocomplete
              renderInput={params => (
                <TextField
                  error={Boolean(errors.name)}
                  fullWidth
                  id="name"
                  inputRef={nameFieldRef}
                  label="Nickname"
                  onBlur={handleBlur}
                  onChange={() => setFieldValue('name', nameFieldRef.current?.value)} // Handles individual input changes
                  size="small"
                  variant="outlined"
                  color="secondary"
                  {...params}
                />
              )}
              size="small"
            />
          </Grid>
          <Grid item xs={5}>
            <TextField
              defaultValue={location.street}
              disabled
              fullWidth
              label="Address"
              size="small"
              variant="outlined"
              color="secondary"
            />
          </Grid>
          <Grid component={Box} item position="relative" xs={2}>
            <PrimaryActions />
          </Grid>
          {location.deliveryInstructionsSupported && (
            <Grid item xs={12}>
              <TextField
                defaultValue={location.deliveryInstructions}
                error={Boolean(errors.deliveryInstructions)}
                fullWidth
                helperText={
                  <Box component="span" display="flex" justifyContent="flex-end">
                    <Typography variant="caption">
                      {instrCount} / {MAX_DELIVERY_INSTRUCTION_LIMIT} characters
                    </Typography>
                  </Box>
                }
                id="deliveryInstructions"
                inputProps={{ maxLength: MAX_DELIVERY_INSTRUCTION_LIMIT }}
                label="Delivery Instructions"
                onBlur={handleBlur}
                onChange={e => {
                  setInstrCount(e.target.value.length)
                  handleChange(e)
                }}
                placeholder="Door code, who to ask for when we arrive, etc…"
                size="small"
                variant="outlined"
                color="secondary"
              />
            </Grid>
          )}
          <Grid component={Box} item textAlign="right" xs={12}>
            <Button onClick={handleCancel} size="small" style={{ marginRight: '8px' }}>
              Cancel
            </Button>
            <ButtonSubmit
              color="primary"
              disabled={isUpdatingSavedLocation}
              onClick={handleSubmit}
              size="small"
              submitting={isUpdatingSavedLocation}
              variant="contained"
            >
              Save
            </ButtonSubmit>
          </Grid>
          {updateSavedLocationError && (
            <Typography align="center" color="error">
              {updateSavedLocationError}
            </Typography>
          )}
        </Grid>
      )}
    </Formik>
  )
}

export default EditSavedLocationForm
